import { render, staticRenderFns } from "./clientUsersTable.vue?vue&type=template&id=a70d7968&"
import script from "./clientUsersTable.vue?vue&type=script&lang=js&"
export * from "./clientUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports